import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';

import { CircularProgress, IconButton } from '@mui/material';
import { FileUpload } from '@mui/icons-material';

import TranslationsContext from '../../Container/Language/TranslationsContext';
import StateContext from '../../HO/State/StateContext';

const ExportLinkButton = (props) => {
  const { t } = useContext(TranslationsContext);
  const { sendRequest } = useContext(StateContext);

  const { exportLinkRoute, form } = props;

  const [loading, setLoading] = useState(false);

  const iconButtonProps = {
    title: t('app:common:export'),
    onClick() {
      setLoading(true);

      sendRequest(exportLinkRoute, {
        body: {
          ...form,
          export: true,
        },
      }).then((response) => {
        if (response && response.success && response.data && response.data.report) {
          window.open(response.data.report, '_blank');
        }
        setLoading(false);
      }).catch(() => {
        setLoading(false);
      });
    },
    disabled: loading,
  };

  return (
    <IconButton {...iconButtonProps}>
      {loading ? (<CircularProgress size={24} />) : (<FileUpload />)}
    </IconButton>
  );
};

ExportLinkButton.propTypes = {
  exportLinkRoute: PropTypes.string.isRequired,
  form: PropTypes.instanceOf(Object).isRequired,
};

ExportLinkButton.defaultProps = {

};

export default ExportLinkButton;
